import React, { useEffect, useState, useContext, useMemo, useRef } from "react";
import { useParams, Link } from "react-router";
import { getInfo, saveVinculosOrder } from "../services/infoService";
import { AppContext } from "../AppContext";
import { PLATAFORMA_LABELS } from "../config/api";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { PROFILES } from "../const";
import _ from "lodash";

interface Vinculo {
  seccion: any;
  seccion_destacada: any;
  id: string;
  id_seccion: string;
  titulo: string;
  vinculo_rapido?: string;
  numero_visitas?: string;
  orden?: number;
  id_tipo_perfil?: number;
  pdf_url?: string;
  miniatura_url?: string;
}

interface Info {
  perfil?: string;
  videos?: number;
  text2?: string;
}

const TUTORIAL_IMAGES = [
  "https://lh3.googleusercontent.com/aida-public/AB6AXuChDnalLnxYWaZCgdH_KWNnp0AXYGck1z70YtTW91FN5RIQMzUAIaxgUAHt64NOWo5kxKklCtMdvN_FLvg_RDHheLzG7CWdftNcB4RRaloeQza4E-Tm6cBU1fQM7jrMsftlBetWfeMNA3C4piQv7JbbZDa4OgvusajJXrDPqbteDJPm4kXRilNu0VmW5PCbYHOjyu7ofDN5qzkva-YteZJrHx_UT3hbIa9CTXPMaL_NRMnt6JE8VNTM_mk4ctgWcpch4Z7siz7okKCK",
  "https://lh3.googleusercontent.com/aida-public/AB6AXuDK9ADe5_JgKNiPpVQ2Zcp5_OwnSkKMCsfmbBakv0tjbGSWDBU7HHhrg8bXdqbNS6eQrRbjekY5s5_RRfs30FhjlvvWkkrWIh3wAeXkeqoNi5VDJUhc7IzQlP4R1u1bG7ZaFA22r2DdzZ0Q6ncsOkarOksrMZAY6A9Gz-mvdZpKdsjsKcum6UpmTHqV70JbaWUscX_pqd-bLI66tBy1UDV2k5065pQTPxVKVan5FlNh5pDRk0WA-sP4whaTBh3kjb4ManQrNKm8xJ_o",
  "https://lh3.googleusercontent.com/aida-public/AB6AXuA2K6VVGny4Nh1vmeuP5_AmghQDC1HbdkfuYreJ2YbIj5joBQQC_pWiim8xEd4ORzpuHlnR1otfE2m6RN5o6ONTa3mCVowxIDfVQllHLSmddayBbFashidSZqNH6E2fOlLIN4jAzF-AfGDMvG5nteUykAhK4VMphP2nzYE5Mf1Z4CD5Hjdkp3QzbUUafbN_jCT0NymXSYpn13AikzuQlMGMft-yU65WIfi7pwC9wur9qsmDykDB7N3FNhrxhfaOaf6UDliASVn0tST9",
  "https://lh3.googleusercontent.com/aida-public/AB6AXuAbIbd_b4wIyscwqMeJb9x4A39YAD5jIilnCJIxZNcV4wkG3OG4wCVz1mcVO9u-DTweJRZMdTEan7fMQB5ZzcDpwHa0KZU9nY5_SjOX9Nzkw6wqVh-ewckb1OUibfgPMQPKUQHvQpbQ9NIm2SAvYLwMnOWAUdPdLl3js9-RATWuAxvQW7amU5gR0ypwcHfzbvT1oXhtlbHPbjd4Yi1R5VNrpu_YVpDN-f91UeRy4fQeNBuTErJ6tiFj3__aq6iKEYtFoFlCdbvA6mIh",
  "https://lh3.googleusercontent.com/aida-public/AB6AXuA6EXJw_Etrpz3SybMDGFOywTDndzUKojswizVeGMvJH4-bl_Y0rfpii18V3K_nxYtm-nhl3g5JUL9DKhLxDk1GuPR2po-BuF0eUSGv-4DCF2UvqA4FuAKFnUMrrMEQ6swAb-EBYF3pW7WFHUoAHzsokTbMIKIcMMJ0nIi3P6flt_M1GLA4RVnn4HBBWkLIkj7gbLLEntEhE5oe2kTNZtbWTkf7siJQnsop-cp94C0l2r3oyki5VvZbzlYqYbeGiZzGXI8-_QWC5lEM",
];

const Body: React.FC = () => {
  const context = useContext(AppContext);
  const isFetchingInfo = useRef(false);
  const isReordering = useRef(false);
  const dragItem = useRef<number | null>(null);
  const dragOverItem = useRef<number | null>(null);
  const isSoporte = context?.data?.isSoporte;

  const { hash } = useParams<{ hash: string }>();
  const [vinculos, setVinculos] = useState<Vinculo[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [draggedIndex, setDraggedIndex] = useState<number | null>(null);
  const [dragOverIndex, setDragOverIndex] = useState<number | null>(null);
  const [selectedProfile, setSelectedProfile] = useState<string>("1");
  const [loads, setLoads] = useState(0);

  const [info, setInfo] = useState<Info>({
    perfil: "",
    videos: 0,
    text2: "Vínculos de ayuda para todos los perfiles",
  });

  const localData = localStorage.getItem("data");
  const localDataParsed = useMemo(() => {
    let parsedData: any = {};
    try {
      parsedData = JSON.parse(localData || "{}");
    } catch (error) {
      console.error('Error al analizar JSON:', error);
    }
    return parsedData;
  }, [localData]);

  const contextVinculos = context?.data?.vinculos;
  const vinculosLength = contextVinculos?.length ?? 0;
  const plataformaActual = context?.plataforma;
  const perfilActual = context?.data?.perfil;
  const activeSeccionId = context?.activeSeccionId;
  const activeView = context?.activeView;

  const perfilesDisponibles = useMemo(() => {
    return Object.keys(_.groupBy(vinculos.filter((v) => String(v.id_seccion) === String(activeSeccionId) && v.id_tipo_perfil !== null), 'id_tipo_perfil'))
  }, [vinculos, activeSeccionId]);

  const activeVinculos = useMemo(() => {
    if (!vinculos) return [];
    console.log("Filtrando vínculos activos para la sección:", activeSeccionId, "y perfil:", selectedProfile, vinculos);
    return vinculos
      .filter((v) =>
        String(v.id_seccion) === String(activeSeccionId) &&
        v.id !== null &&
        v.id_tipo_perfil !== null &&
        String(v.id_tipo_perfil) === String(selectedProfile)
      )
      .sort((a, b) => (Number(a.orden) || 0) - (Number(b.orden) || 0));
  }, [vinculos, activeSeccionId, selectedProfile]);

  const globalVinculos = useMemo(() => {
    if (!vinculos) return [];
    return vinculos
      .filter((v) => v.id !== null)
      .sort((a, b) => (Number(a.orden) || 0) - (Number(b.orden) || 0));
  }, [vinculos]);

  const globalVinculosRapidos = useMemo(() => {
    return globalVinculos.filter((v) => v.vinculo_rapido === "TRUE");
  }, [globalVinculos]);

  const globalVinculosPopulares = useMemo(() => {
    return [...globalVinculos]
      .filter((v) => Number(v.numero_visitas) > 0)
      .sort((a, b) => (Number(b.numero_visitas) || 0) - (Number(a.numero_visitas) || 0))
      .slice(0, 6);
  }, [globalVinculos]);

  const sectionName = activeVinculos.length > 0 ? activeVinculos[0].seccion : "Tutoriales";

  useEffect(() => {
    if (perfilesDisponibles.length > 0) {
      if (!perfilesDisponibles.includes(String(selectedProfile))) {
        setSelectedProfile(perfilesDisponibles[0]);
      }
    }
  }, [perfilesDisponibles, selectedProfile]);

  useEffect(() => {
    if (contextVinculos && contextVinculos.length > 0 && !isReordering.current) {
      setVinculos(contextVinculos);
      setIsLoading(false);
    }
  }, [contextVinculos]);

  useEffect(() => {
    if (isReordering.current) return;

    const fetchData = async () => {
      let hashLocal = localStorage.getItem("hash");
      if (hash && hash !== hashLocal) {
        localStorage.setItem("hash", hash);
        hashLocal = hash;
      }

      const HASH_FINAL = hash || hashLocal;

      // if (!HASH_FINAL) {
      //   setIsLoading(false);
      //   return;
      // }

      if (vinculosLength > 0) {
        setVinculos(context?.data?.vinculos || []);
        setIsLoading(false);
        return;
      }
      if (!isFetchingInfo.current && vinculosLength === 0 && loads < 3) {
        try {
          isFetchingInfo.current = true;
          setIsLoading(true);
          await getInfo(context, HASH_FINAL, plataformaActual);
          setVinculos(context?.data?.vinculos || []);
        } catch (error) {
          console.error("Error cargando datos en la recarga:", error);
        } finally {
          setTimeout(() => {
            setIsLoading(false);
            isFetchingInfo.current = false;
            setLoads((prev) => prev + 1);
          }, 500);
        }
      } else if (vinculosLength === 0 && loads >= 3) {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [hash, vinculosLength, plataformaActual, context]);

  useEffect(() => {
    if (!context || !plataformaActual) return;

    const plataformaLabel = PLATAFORMA_LABELS[plataformaActual] || "Plataforma";
    const perfil = perfilActual || localDataParsed?.perfil || "";
    const totalVinculos = vinculosLength > 0
      ? vinculosLength
      : localDataParsed?.vinculos?.length || 0;

    setInfo({
      perfil,
      videos: totalVinculos,
      text2: perfil
        ? `Vínculos de ayuda para ${plataformaLabel} — perfil ${perfil}`
        : `Vínculos de ayuda para ${plataformaLabel}`,
    });
  }, [plataformaActual, perfilActual, vinculosLength, localDataParsed?.perfil, localDataParsed?.vinculos?.length, context]);

  const handleDragStart = (index: number) => {
    if (!isSoporte) return;
    dragItem.current = index;
    setDraggedIndex(index);
  };

  const handleDragEnter = (index: number) => {
    if (!isSoporte) return;
    dragOverItem.current = index;
    setDragOverIndex(index);
  };

  const handleDragEnd = async () => {
    if (!isSoporte || dragItem.current === null || dragOverItem.current === null) {
      setDraggedIndex(null);
      setDragOverIndex(null);
      return;
    }

    if (dragItem.current === dragOverItem.current) {
      setDraggedIndex(null);
      setDragOverIndex(null);
      return;
    }

    isReordering.current = true;

    const vinculosA_Preservar = vinculos.filter((v) => {
      const esMismaSeccion = String(v.id_seccion) === String(activeSeccionId);
      const esMismoPerfil = v.id_tipo_perfil !== null && String(v.id_tipo_perfil) === String(selectedProfile);
      return !esMismaSeccion || !esMismoPerfil || v.id === null;
    });

    const listaActivaOrdenada = [...activeVinculos];
    const [draggedItem] = listaActivaOrdenada.splice(dragItem.current, 1);
    listaActivaOrdenada.splice(dragOverItem.current, 0, draggedItem);

    const listaActivaConNuevoOrden = listaActivaOrdenada.map((vinculo, index) => ({
      ...vinculo,
      orden: index + 1
    }));

    const updatedGlobalVinculos = [...vinculosA_Preservar, ...listaActivaConNuevoOrden];

    setVinculos(updatedGlobalVinculos);

    if (context?.setData) {
      context.setData({
        ...context.data,
        vinculos: updatedGlobalVinculos,
      });
    }

    dragItem.current = null;
    dragOverItem.current = null;
    setDraggedIndex(null);
    setDragOverIndex(null);

    try {
      await saveVinculosOrder(listaActivaConNuevoOrden);
    } catch (err) {
      console.error("Error guardando el orden:", err);
    } finally {
      setTimeout(() => {
        isReordering.current = false;
      }, 200);
    }
  };

  const handleChange = async (event: any) => {
    const selectedPerfil = event.target.value as string;
    setSelectedProfile(selectedPerfil);
  }

  const renderSkeleton = () => (
    <div className="fadeIn animate-pulse">
      <div className="mb-8 flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div className="text-center md:text-left w-full md:w-auto">
          <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded-xl w-48 mb-3 mx-auto md:mx-0"></div>
          <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded-xl w-full max-w-md mx-auto md:mx-0"></div>
        </div>
        <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded-full w-40 mx-auto md:mx-0"></div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[1, 2, 3].map((n) => (
          <div key={n} className="bg-surface-container-lowest border border-outline-variant overflow-hidden flex flex-col rounded-3xl h-[380px]">
            <div className="aspect-video w-full bg-gray-200 dark:bg-gray-700" />
            <div className="p-6 flex-1 flex flex-col justify-between">
              <div>
                <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded-full w-16 mb-3" />
                <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded-xl w-full mb-2" />
                <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded-xl w-3/4 mb-4" />
              </div>
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded-full w-24" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  if (isLoading) return renderSkeleton();

  const renderSeccionView = () => (
    <>
      <div className="mb-8 flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div className="text-center md:text-left">
          <h1 className="font-display-lg text-display-lg text-primary mb-2">
            {sectionName}
          </h1>
          <p className="font-body-lg text-body-lg text-on-surface-variant max-w-2xl">
            {info.text2}
            {info.videos ? ` - (${activeVinculos.length}) vínculos disponibles` : ''}
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-center md:justify-end gap-3">
          {isSoporte && (
            <div className="min-w-[160px]">
              <FormControl fullWidth size="small">
                <InputLabel id="Perfil">Perfil</InputLabel>
                <Select
                  labelId="Perfil"
                  id="select"
                  value={selectedProfile}
                  label="Perfil"
                  onChange={handleChange}
                  className="rounded-xl"
                >
                  {PROFILES.map((profile) => (
                    perfilesDisponibles.includes(String(profile.id)) && (
                      <MenuItem key={profile.id} value={profile.id}>
                        {profile.nombre}
                      </MenuItem>
                    )
                  ))}
                </Select>
              </FormControl>
            </div>
          )}
          {isSoporte && (
            <Link
              to={`/vinculos/new/${activeSeccionId}`}
              className="flex w-fit items-center gap-2 bg-surface-container-high px-4 py-2 rounded-full text-primary hover:bg-primary-fixed transition-colors text-label-md font-label-md no-underline"
            >
              <span className="material-symbols-outlined text-sm">add</span>
              Crear Vínculo
            </Link>
          )}
        </div>
      </div>

      <div className={`grid grid-cols-1 lg:grid-cols-4 gap-8 items-start ${activeVinculos.length === 0 ? "" : "xl:grid-cols-5"}`}>
        <div className="lg:col-span-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-6 transition-all duration-300">
          {activeVinculos.length > 0 ? (
            activeVinculos.map((vinculo, idx) => {
              const isBeingDragged = idx === draggedIndex;
              const isDragOverTarget = idx === dragOverIndex;

              return (
                <div
                  key={vinculo.id}
                  id={`vinculo-${vinculo.id}`}
                  draggable={isSoporte}
                  onDragStart={() => handleDragStart(idx)}
                  onDragEnter={() => handleDragEnter(idx)}
                  onDragEnd={handleDragEnd}
                  onDragOver={(e) => e.preventDefault()}
                  className={`bg-surface-container-lowest border overflow-hidden flex flex-col group rounded-3xl no-underline hover:shadow-lg transition-all duration-300 transform-gpu ${isSoporte ? "cursor-grab active:cursor-grabbing" : ""} ${isBeingDragged ? "opacity-30 scale-95 border-primary/30" : "opacity-100 scale-100"} ${isDragOverTarget && !isBeingDragged ? "border-primary-fixed bg-primary/5 scale-[1.02] ring-2 ring-primary/20" : "border-outline-variant"}`}
                >
                  <Link to={`/link/${vinculo.id}`} className="no-underline flex flex-col flex-1">
                    <div className="aspect-video relative overflow-hidden bg-surface-container-high">
                      <img
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        src={vinculo.miniatura_url || TUTORIAL_IMAGES[idx % TUTORIAL_IMAGES.length]}
                        alt={vinculo.titulo}
                      />
                      <div className="absolute inset-0 bg-primary/20 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 cursor-pointer">
                        <span className="material-symbols-outlined text-white text-6xl" style={{ fontVariationSettings: "'FILL' 1" }}>
                          play_circle
                        </span>
                      </div>

                      {isSoporte && (
                        <div className="absolute top-3 left-3 bg-black/50 text-white p-1.5 rounded-xl backdrop-blur-sm opacity-60 group-hover:opacity-100 transition-opacity">
                          <span className="material-symbols-outlined text-sm block">drag_indicator</span>
                        </div>
                      )}

                      {vinculo.vinculo_rapido === "TRUE" && (
                        <span className="absolute bottom-3 right-3 bg-secondary text-white text-xs font-bold px-2 py-1 rounded-full">
                          Rápido
                        </span>
                      )}
                    </div>

                    <div className="p-6 flex-1 flex flex-col">
                      {isSoporte && (
                        <span className="text-[10px] font-extrabold uppercase tracking-widest mb-2 block text-secondary">
                          Tutorial (Orden: {vinculo.orden})
                        </span>
                      )}
                      <h3 className="font-headline-md text-headline-md text-on-surface mb-3 leading-tight line-clamp-3">
                        {vinculo.titulo}
                      </h3>

                      <div className="flex items-center justify-between gap-2 text-on-surface-variant text-label-sm font-label-sm mt-auto" onClick={(e) => e.stopPropagation()}>
                        {vinculo.numero_visitas !== undefined && (
                          <div className="flex items-center gap-2 text-on-surface-variant text-label-md font-label-md">
                            <span className="material-symbols-outlined text-sm">visibility</span>
                            {vinculo.numero_visitas} vistas
                          </div>
                        )}
                        {isSoporte && (
                          <Link
                            to={`/vinculos/${vinculo.id}`}
                            className="flex w-fit items-center gap-2 bg-surface-container-high px-4 py-2 rounded-3xl text-primary hover:bg-primary-fixed transition-colors text-label-md font-label-md no-underline"
                          >
                            <span className="material-symbols-outlined text-sm">edit</span>
                            Editar
                          </Link>
                        )}
                      </div>
                    </div>
                  </Link>
                </div>
              );
            })
          ) : (
            <div className="col-span-full py-12 text-center bg-surface-container-low rounded-3xl border border-outline-variant flex flex-col items-center justify-center gap-4">
              <span className="material-symbols-outlined text-6xl text-outline-variant mb-4">video_library</span>
              <h3 className="font-headline-md text-headline-md text-on-surface mb-2">No hay videos en esta sección</h3>
              <p className="text-on-surface-variant text-body-md">
                Selecciona otra sección en el menú lateral o intenta con una plataforma diferente.
              </p>
            </div>
          )}

          {activeVinculos.length > 0 && (
            <div className="bg-primary p-8 rounded-3xl border-none flex flex-col justify-between group hover:shadow-lg transition-shadow">
              <div>
                <span className="material-symbols-outlined text-surface-bright text-5xl mb-6 block">
                  help_center
                </span>
                <h3 className="font-headline-md text-headline-md text-white mb-4">
                  ¿No encuentras lo que buscas?
                </h3>
                <p className="text-primary-fixed text-body-md mb-8">
                  Nuestro equipo técnico está listo para asistirte en tiempo real mediante nuestro centro de soporte.
                </p>
              </div>
              <a
                href="https://web.colpegasus.com"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-surface-bright text-primary px-6 py-3 font-label-md text-label-md flex items-center justify-center gap-2 hover:bg-surface-container-high transition-all rounded-full no-underline w-fit"
              >
                Contactar Soporte
                <span className="material-symbols-outlined text-sm">arrow_forward</span>
              </a>
            </div>
          )}
        </div>

        {activeVinculos.length > 0 && (
          <aside className="hidden lg:block lg:col-span-1 sticky top-16 max-h-[calc(100vh-4rem)] overflow-y-auto pr-2 border-l border-outline-variant/40 pl-6">
            <h2 className="text-on-surface font-label-lg text-label-lg uppercase tracking-wider mb-4 opacity-70">
              En esta página
            </h2>
            <nav className="flex flex-col gap-1">
              {activeVinculos.map((vinculo) => (
                <button
                  key={vinculo.id}
                  onClick={() => {
                    document.getElementById(`vinculo-${vinculo.id}`)?.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                    });
                  }}
                  className="text-left py-1.5 text-body-md text-on-surface-variant hover:text-primary hover:pl-1 transition-all duration-200 border-none bg-transparent cursor-pointer font-normal line-clamp-2"
                >
                  {vinculo.titulo}
                </button>
              ))}
            </nav>
          </aside>
        )}
      </div>
    </>
  );

  const renderRapidosView = () => (
    <>
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-1">
          <span className="material-symbols-outlined text-primary text-3xl">bolt</span>
          <h1 className="font-display-lg text-display-lg text-primary m-0">
            Vínculos Rápidos
          </h1>
        </div>
        <p className="font-body-lg text-body-lg text-on-surface-variant max-w-2xl">
          Accesos directos para resolver tus dudas al instante
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {globalVinculosRapidos.length > 0 ? (
          globalVinculosRapidos.map((vinculo, idx) => (
            <Link
              key={vinculo.id}
              to={`/link/${vinculo.id}`}
              className="bg-surface-container-lowest border border-outline-variant overflow-hidden flex flex-col group rounded-3xl no-underline hover:shadow-lg transition-all duration-300 transform-gpu"
            >
              <div className="aspect-video relative overflow-hidden bg-surface-container-high">
                <img
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  src={TUTORIAL_IMAGES[idx % TUTORIAL_IMAGES.length]}
                  alt={vinculo.titulo}
                />
                <div className="absolute inset-0 bg-primary/20 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 cursor-pointer">
                  <span className="material-symbols-outlined text-white text-6xl" style={{ fontVariationSettings: "'FILL' 1" }}>
                    play_circle
                  </span>
                </div>
                <span className="absolute bottom-3 right-3 bg-secondary text-white text-xs font-bold px-2 py-1 rounded-full">
                  Rápido
                </span>
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <h3 className="font-headline-md text-headline-md text-on-surface mb-3 leading-tight line-clamp-3">
                  {vinculo.titulo}
                </h3>
                <div className="flex items-center gap-2 text-on-surface-variant text-label-sm font-label-sm mt-auto">
                  <span className="material-symbols-outlined text-sm">visibility</span>
                  {vinculo.numero_visitas || 0} vistas
                </div>
              </div>
            </Link>
          ))
        ) : (
          <div className="col-span-full py-12 text-center bg-surface-container-low rounded-3xl border border-outline-variant flex flex-col items-center justify-center gap-4">
            <span className="material-symbols-outlined text-6xl text-outline-variant mb-4">bolt</span>
            <h3 className="font-headline-md text-headline-md text-on-surface mb-2">No hay vínculos rápidos</h3>
            <p className="text-on-surface-variant text-body-md">
              Aún no hay vínculos marcados como rápidos disponibles.
            </p>
          </div>
        )}
      </div>
    </>
  );

  const renderPopularesView = () => (
    <>
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-1">
          <span className="material-symbols-outlined text-primary text-3xl">trending_up</span>
          <h1 className="font-display-lg text-display-lg text-primary m-0">
            Vínculos Populares
          </h1>
        </div>
        <p className="font-body-lg text-body-lg text-on-surface-variant max-w-2xl">
          Los tutoriales más vistos por la comunidad
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {globalVinculosPopulares.length > 0 ? (
          globalVinculosPopulares.map((vinculo, idx) => (
            <Link
              key={vinculo.id}
              to={`/link/${vinculo.id}`}
              className="bg-surface-container-lowest border border-outline-variant overflow-hidden flex flex-col group rounded-3xl no-underline hover:shadow-lg transition-all duration-300 transform-gpu"
            >
              <div className="aspect-video relative overflow-hidden bg-surface-container-high">
                <img
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  src={TUTORIAL_IMAGES[idx % TUTORIAL_IMAGES.length]}
                  alt={vinculo.titulo}
                />
                <div className="absolute inset-0 bg-primary/20 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 cursor-pointer">
                  <span className="material-symbols-outlined text-white text-6xl" style={{ fontVariationSettings: "'FILL' 1" }}>
                    play_circle
                  </span>
                </div>
                {vinculo.vinculo_rapido === "TRUE" && (
                  <span className="absolute bottom-3 right-3 bg-secondary text-white text-xs font-bold px-2 py-1 rounded-full">
                    Rápido
                  </span>
                )}
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <h3 className="font-headline-md text-headline-md text-on-surface mb-3 leading-tight line-clamp-3">
                  {vinculo.titulo}
                </h3>
                <div className="flex items-center gap-2 text-on-surface-variant text-label-sm font-label-sm mt-auto">
                  <span className="material-symbols-outlined text-sm">visibility</span>
                  {vinculo.numero_visitas} vistas
                </div>
              </div>
            </Link>
          ))
        ) : (
          <div className="col-span-full py-12 text-center bg-surface-container-low rounded-3xl border border-outline-variant flex flex-col items-center justify-center gap-4">
            <span className="material-symbols-outlined text-6xl text-outline-variant mb-4">trending_up</span>
            <h3 className="font-headline-md text-headline-md text-on-surface mb-2">No hay vínculos populares</h3>
            <p className="text-on-surface-variant text-body-md">
              Aún no hay vínculos con visitas registradas.
            </p>
          </div>
        )}
      </div>
    </>
  );

  return (
    <div className="fadeIn">
      {activeView === 'seccion' && renderSeccionView()}
      {activeView === 'rapidos' && renderRapidosView()}
      {activeView === 'populares' && renderPopularesView()}
    </div>
  );
};

export default Body;
